import axios from "axios";

export enum AcaoEvento {
    Home = "Home",
    ConsultarCPF = "ConsultarCPF",
    ClienteNaoEncontrado = "ClienteNaoEncontrado",
    DadosInvalidos = "DadosInvalidos",
    Login = "Login",
    TokenEnviado = "TokenEnviado",
    ValidarToken = "ValidarToken",
    Autenticacao2FA = "Autenticacao2FA",
    AutenticacaoPorCPF = "AutenticacaoPorCPF",
    DadosNaoLocalizados = "DadosNaoLocalizados",
    VisualizarOpcoesPagamento = "VisualizarOpcoesPagamento",
    FormalizarAcordo = "FormalizarAcordo",
    Pagamento = "Pagamento",
    VisualizarDivida = "VisualizarDivida",
    VisualizarAcordo = "VisualizarAcordo",
    DownloadBoleto = "DownloadBoleto",
    EnvioBoletoPorSMS = "EnvioBoletoPorSMS",
    EnvioBoletoPorEmail = "EnvioBoletoPorEmail",
    EnvioBoletoPorWhatsApp = "EnvioBoletoPorWhatsApp",
}

export type EventoRequestProps = {
    acao: AcaoEvento;
    trackId?: string; 
    contratoId?: string;
    cpfCnpj?: string;
    crm?: string;
    carteiraId?: number;
}

interface RequestProps extends EventoRequestProps {
	canalId: string;
	ip: string;
	userAgent: string;
	url: string;
};

type IPifyResponseProps = {
	ip: string
}

export async function registrarEventoAsync(value: EventoRequestProps) {
	return axios.get<IPifyResponseProps>("https://api.ipify.org/?format=json")
		.then(
			({ data: { ip } }) => {
				const request = {
					canalId: process.env.REACT_APP_ID,
					ip: ip,
					userAgent: window.navigator.userAgent,
					url: window.location.href,
					...value
				} as RequestProps;

				return axios.post(`${process.env.REACT_APP_API_URL}/incluir-evento`, request);
			}
		);
}

